import * as yup from 'yup';
import api from '@/services/api';
import { DOCUMENT_TYPE } from "@/utils/constants";
type DocumentRule = {
  length: number;
  type: 'numeric' | 'alphanumeric';
  exact: boolean;
  min: number;
};
const documentRules: Record<number, DocumentRule> = {
  [DOCUMENT_TYPE.DNI]: { length: 8, type: 'numeric', exact: true, min: 8 },
  [DOCUMENT_TYPE.CARNET_EXTRANJERIA]: { length: 12, type: 'alphanumeric', exact: false, min: 3 },
  [DOCUMENT_TYPE.PASAPORTE]: { length: 12, type: 'alphanumeric', exact: false, min: 3 }
};
export const teamSchema = yup.object({
  name: yup.string().required('Nombre es requerido')          
  .test(
    'checkDuplicateName',
    'El Nombre ya existe',
    async function (value) {
      const { id, tournamentId  } = this.options.context || {};
      
      if (!value) return true; // Skip if empty — let `.required` handle it
      if(!tournamentId) return true;
      try {
        const response = await api.get(`/team/validate-name?idTeam=${id}&name=${value}`);

        return !response.data; 
      } catch (error) {
        return this.createError({
          message: 'Error al validar el nombre del equipo',
        });
      }
    }
  ),
  tournamentIds: yup
  .array()
  .of(yup.number()) 
  .min(1, 'Debes seleccionar al menos un torneo') 
  .required('Torneo es requerido'),
  companyId: yup.number().nullable().required('Empresa/Institución es requerido'),
  photo: yup
  .mixed()
  .nullable()
  .when('urlPhoto', {
    is: (urlPhoto:any) => !urlPhoto, // if urlPhoto is empty
    then: (schema) => schema
      .required('Imagen es requerida')
      .test('fileSize', 'La imagen no debe pesar más de 2MB', (value: any) => {
        if (!value) return false;
        return value.size <= 2 * 1024 * 1024; // 2MB max
      })
      .test('fileType', 'Formato del archivo no es válido', (value: any) => {
        if (!value) return false;
        const supportedFormats = ['image/jpg', 'image/jpeg', 'image/png'];
        return supportedFormats.includes(value.type);
      }),
    otherwise: (schema) => schema.notRequired(),
  }),
  //description: yup.string().required('Descripción es requerida'),
  documentTypeId: yup
    .number()
    .nullable()
    .when('documentNumber', {
      is: (val: string | null | undefined) => !!val,
      then: (schema) => schema.required('Debe seleccionar el tipo de documento'),
      otherwise: (schema) => schema.nullable()
    }),
    documentNumber: yup
    .string()
    .nullable()
    .test('document-validation', 'Documento inválido', function (value) {
      const { documentTypeId } = this.parent as {
        documentTypeId?: number | null;
      };
      if (!value) return true;
      if (!documentTypeId) return true;
      const rule = documentRules[documentTypeId];
      if (!rule) return true;

      if (rule.type === 'numeric' && !/^\d+$/.test(value)) {
        return this.createError({ message: 'El documento debe ser numérico' });
      }

      if (rule.type === 'alphanumeric' && !/^[a-zA-Z0-9]+$/.test(value)) {
        return this.createError({ message: 'El documento debe ser alfanumérico' });
      }

      if (rule.exact && value.length !== rule.length) {
        return this.createError({
          message: `El documento debe tener exactamente ${rule.length} caracteres`
        });
      }
      if (!rule.exact && value.length > rule.length) {
        return this.createError({
          message: `El documento debe tener máximo ${rule.length} caracteres`
        });
      }

      if (!rule.exact && rule.min && value.length < rule.min) {
        return this.createError({
          message: `Debe tener al menos ${rule.min} caracteres`
        });
      }
      return true;
    }),
    phoneNumber: yup
    .string()
    .nullable()
    .transform((value) => value === '' ? null : value)
    .matches(/^\d+$/, 'El teléfono/celular solo debe contener números')
    .min(7, 'El teléfono/celular debe tener mínimo 7 dígitos')
    .max(20, 'El teléfono/celular debe tener máximo 20 dígitos'),
    managerName: yup
    .string()
    .nullable()
    .transform((value) => value === '' ? null : value)
    .min(5, 'El nombre del apoderado/gerente debe tener mínimo 5 caracteres')
    .max(100, 'El nombre del apoderado/gerente debe tener máximo 100 caracteres'),
    contactEmail: yup
    .string()
    .nullable()
    .transform((value) => value === '' ? null : value)
    .trim()
    .matches(
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      'Correo electrónico del contacto inválido'
    )
    .max(100, 'El correo electrónico del contacto debe tener máximo 100 caracteres')
}); 